import { CHECKOUT_OPTIMISTIC_UPDATE, CHECKOUT_CHANGES_ACCEPTED, CHECKOUT_CLEARCART, CHECKOUT_UPDATE_SUCCESS, } from "../../action-creators";
import { PAGE_UPDATE_SUCCESS, PAGE_LOAD_SUCCESS, } from "SiteLayout/CurrentPage/action-creators";
import { isComponentFor } from "Shared/resolve-component";
import clone from "clone";
import { applyPendingChanges as applyCartPendingChanges } from "../../../Cart/reducer";
import { CART_LOAD_FAILURE } from "../../../Cart/action-creators";
export default function (pageState = null, checkoutState, action) {
    const state = checkoutState ||
        (isComponentFor(pageState.componentName, "Avensia.Shop.Features.Checkout.Pages.Checkout.CheckoutPageViewModel")
            ? pageState
            : null);
    switch (action.type) {
        case CHECKOUT_OPTIMISTIC_UPDATE: {
            const diff = [action.diff];
            let newState = applyPendingChanges(state, diff);
            newState.pendingChanges = (newState.pendingChanges || []).concat(diff);
            newState.scrollPosition = undefined;
            return newState;
        }
        case CART_LOAD_FAILURE: {
            const firstPendingChange = state.pendingChanges[0];
            if (!firstPendingChange) {
                return state;
            }
            return Object.assign({}, state, {
                isLoading: false,
                pendingChanges: [],
                cart: Object.assign(Object.assign({}, state.cart), { items: state.cart.items.map((item) => {
                        let updatedItem;
                        Object.keys(firstPendingChange.cart.items).forEach((code) => {
                            if (code === item.lineItem.code) {
                                const pendingItemChange = firstPendingChange.cart.items[code];
                                updatedItem = {
                                    product: item.product,
                                    lineItem: Object.assign(Object.assign({}, item.lineItem), { discountValue: pendingItemChange.previousDiscountValue, discountType: pendingItemChange.previousDiscountType, ignoreAvailability: pendingItemChange.previousIgnoreAvailability, quantity: pendingItemChange.previousQuantity, unitShortName: pendingItemChange.previousUnitShortName, isProductSample: pendingItemChange.previousIsProductSample, selectedVariant: Object.assign(Object.assign({}, item.lineItem.selectedVariant), { unitShortName: pendingItemChange.previousUnitShortName }) }),
                                };
                            }
                        });
                        return updatedItem || item;
                    }) }),
            });
        }
        case CHECKOUT_CHANGES_ACCEPTED: {
            const acceptedChangeIds = action.changes.map((c) => c.id);
            let checkoutPage = Object.assign({}, state);
            checkoutPage.pendingChanges = checkoutPage.pendingChanges.filter((p) => acceptedChangeIds.indexOf(p.id) === -1);
            return checkoutPage;
        }
        case CHECKOUT_CLEARCART: {
            return Object.assign({}, state);
        }
        case CHECKOUT_UPDATE_SUCCESS: {
            let newState = action
                .page;
            newState.scrollPosition = undefined;
            if (state.pendingChanges && state.pendingChanges.length) {
                newState = applyPendingChanges(newState, state.pendingChanges);
                newState.pendingChanges = state.pendingChanges;
            }
            else {
                newState.pendingChanges = [];
            }
            return Object.assign({}, state, newState);
        }
        case PAGE_LOAD_SUCCESS:
        case PAGE_UPDATE_SUCCESS: {
            if (isComponentFor(pageState.componentName, "Avensia.Shop.Features.Checkout.Pages.Checkout.CheckoutPageViewModel")) {
                let newState = action
                    .page;
                newState.scrollPosition = undefined;
                if (state.pendingChanges && state.pendingChanges.length) {
                    newState = applyPendingChanges(newState, state.pendingChanges);
                    newState.pendingChanges = state.pendingChanges;
                }
                else {
                    newState.pendingChanges = [];
                }
                return Object.assign({}, state, newState);
            }
            return state;
        }
        default:
            break;
    }
    return state;
}
function applyPendingChanges(state, pendingChanges) {
    const newCartState = applyCartPendingChanges(clone(state.cart, false, 1), pendingChanges.map((change) => change.cart));
    const newState = clone(state, false, 1);
    newState.cart = newCartState;
    return newState;
}
